import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { taskId: Number, taskName: String, taskUrl: String, taskStatus: String }

  connect() {
    window.dispatchEvent(
      new CustomEvent("pdf-annotation:task-created", {
        detail: {
          taskId: this.taskIdValue,
          taskName: this.taskNameValue,
          taskUrl: this.taskUrlValue,
          taskStatus: this.taskStatusValue,
        },
      }),
    )
    this.element.remove()
  }
}
